/** 1234 → "1.2K", 6600000 → "6.6M". */
export function fmtTokens(n) {
  const v = Number(n);
  if (n == null || !Number.isFinite(v)) return '—';
  if (v >= 1e9) return `${(v / 1e9).toFixed(v >= 1e10 ? 0 : 1)}B`;
  if (v >= 1e6) return `${(v / 1e6).toFixed(v >= 1e7 ? 0 : 1)}M`;
  if (v >= 1e3) return `${(v / 1e3).toFixed(v >= 1e4 ? 0 : 1)}K`;
  return String(Math.round(v));
}

/** Dollars with cents; sub-cent amounts keep 4 decimals so small AI costs aren't shown as $0.00. */
export function fmtUsd(n) {
  const v = Number(n);
  if (n == null || !Number.isFinite(v)) return '—';
  if (v > 0 && v < 0.01) return `$${v.toFixed(4)}`;
  return `$${v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
